import React from 'react';
import MapForm from './MapForm';
import { modifyTemplate } from '../../../api';
import {
  setAppBar,
} from '@its/components/lib/Container components/DrawerMenuContainer/actions';
import { connect } from 'react-redux';
import { merge } from '@its/util';
import {
  onModificationSuccess,
  adjustStartPositions,
  setSpecialFeatures,
} from '../util';

export default class extends React.Component {

  static contextTypes = {
    store: React.PropTypes.object.isRequired,
  }

  constructor(props, context) {
    super(props, context);
    this.context.store.dispatch(setAppBar({
      title: 'NEW_MAP',
      navigateBack: true,
    }));

    const onSubmit = (template, map, values) => {
      const result = merge({}, template);
      result.displayTemplateMaps = [...template.displayTemplateMaps];
      const resultMap = merge(map, values, {
        templateId: template.id,
        startPosition: 1,
        rowNumber: 0,
      });
      setSpecialFeatures(resultMap, values);
      result.displayTemplateMaps.push(resultMap);
      adjustStartPositions(result);
      return result;
    };

    const mapStateToProps = (state) => (
      {
        name: 'addMap',
        request: modifyTemplate(state.app.templates.detail.id),
        onSubmit: onSubmit.bind(null, state.app.templates.detail, state.app.templates.maps.detail),
        onSuccess: onModificationSuccess,
        confirmExit: true,
      }
    );

    const AdditionForm = connect(
      mapStateToProps
    )(MapForm);

    this.component = <AdditionForm />;
  }

  render() {
    return this.component;
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Template/Map/MapAddition.js
 **/